import { LEAGUE_TABLE_COLUMNS_STATIC } from "../../constants/Constants";


function download_csv(csv, filename) {
  // CSV FILE
  let csvFile = new Blob([csv], { type: "text/csv" });
  // Download link
  let downloadLink = document.createElement("a");
  // File name
  downloadLink.download = filename;
  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);
  // Make sure that the link is not displayed
  downloadLink.style.display = "none";
  // Add the link to your DOM
  document.body.appendChild(downloadLink);
  // Lanzamos
  downloadLink.click();
}

function getStarRating(row) {
  if (row) {
    const allRows = row.querySelectorAll("div.star-ratings")
    if (allRows && allRows.length > 0) {
      return allRows[0].title.replaceAll(" Stars", "").replaceAll(" Star", "")
    }
  }
  return ""

}
export const export_table_to_csv = (html, filename, date) => {
  const csv = [];
  const rows = html.querySelectorAll("table tr");
  for (let i = 0; i < rows.length; i++) {
    let row = [], cols = rows[i].querySelectorAll("td, th");
    row.push(i === 0 ? "Date" : date);
    
    for (let j = 0; j < cols.length; j++) {
      console.log(cols[j].innerText)
      let colText = cols[j].innerText
      if (colText === "Odds(Back, Lay)") {
        row.push("Back")
        row.push("Lay")
      } else {
        row.push(cols[j].innerText.replace(/[\r\n]+/g, ",").trim())
      }
    }
    row.push(i === 0 ? "Rating" : getStarRating(rows[i]));
    csv.push(row.join(","));
  }
  // Download CSV
  download_csv(csv.join("\n"), filename);
}